import {
  AddressDTO,
  CarrierDTO,
  DeliveryAddress as DeliveryAddressDTO,
  DeliveryDateDTO,
  DeliveryMethods as DeliveryMethodsDTO,
  DropoffMethodDTO,
  OpeningHoursDTO,
  ShipmentMethodDTO,
  ShipmentMethods as ShipmentMethodsDTO,
  type DropOffMethods as DropoffMethodsDTO,
  UnknownDeliveryDateDTO,
} from '@cloudsuite/cs-ordering-defs'
import { is } from 'typia'

export class ShipmentMethods {
  deliveryMethods: DeliveryMethod[]
  dropoffMethods: DropoffMethod[]
  methodsByCategory: (DropoffMethods | DeliveryMethods)[]

  constructor({ shipment_methods, dropoff_methods, methods_by_categories }: DeliveryMethodsDTO) {
    this.deliveryMethods = shipment_methods?.map((m) => new DeliveryMethod(m)) ?? []
    this.dropoffMethods = dropoff_methods?.map((m) => new DropoffMethod(m)) ?? []
    this.methodsByCategory = methods_by_categories?.map((m) => is<DropoffMethodsDTO>(m) ? new DropoffMethods(m as any) : new DeliveryMethods(m as any))
  }
}

export class UnknownDeliveryDate { }

export class Carrier {
  name: string
  id: number
  code: string

  constructor(carrier: CarrierDTO) {
    this.name = carrier.name
    this.id = carrier.id
    this.code = carrier.code
  }
}

export class DeliveryDate {
  date: Date | null

  constructor(date: DeliveryDateDTO | UnknownDeliveryDateDTO) {
    this.date = date instanceof UnknownDeliveryDateDTO ? null : new Date(date.delivery_date)
  }
}

export class DeliveryMethod {
  methodId: string
  name: string
  price: string
  currency: string
  description: string
  serviceLevelDescription: string
  deliveryDate: DeliveryDate
  carrier: Carrier
  timeFrom: string
  timeTo: string

  constructor(method: ShipmentMethodDTO) {
    this.methodId = method.method_id
    this.name = method.name
    this.price = method.price
    this.currency = method.currency
    this.description = method.description
    this.serviceLevelDescription = method.service_level_description
    this.deliveryDate = new DeliveryDate(method.delivery_date)
    this.carrier = new Carrier(method.carrier)
    this.timeFrom = method.time_from
    this.timeTo = method.time_to
  }
}

export class DeliveryAddress {
  street: string
  number: string
  city: string
  zipcode: string
  country: string

  constructor(address: DeliveryAddressDTO) {
    this.street = address.address_1
    this.number = address.house_number
    this.city = address.city
    this.zipcode = address.zipcode
    this.country = address.country_code
  }
}
export class DropoffAddress {
  street: string
  number: string
  city: string
  zipcode: string
  country: string
  latitude: string
  longitude: string

  constructor(address: AddressDTO) {
    this.street = address.street
    this.number = address.number
    this.city = address.city
    this.zipcode = address.zipcode
    this.country = address.country
    this.latitude = address.latitude
    this.longitude = address.longitude
  }
}

export class OpeningHours {
  day: number
  openFrom: string
  openTo: string

  constructor(openingHours: OpeningHoursDTO) {
    this.openFrom = openingHours.open_from
    this.openTo = openingHours.open_to
    this.day = openingHours.day
  }
}

export class DropoffMethod {
  methodId: string
  name: string
  price: string
  currency: string
  deliveryDate: DeliveryDate
  description: string
  carrier: Carrier
  address: DropoffAddress
  openingHours: OpeningHours[]
  distance: number

  constructor(method: DropoffMethodDTO) {
    this.methodId = method.method_id
    this.name = method.name
    this.price = method.price
    this.currency = method.currency
    this.deliveryDate = new DeliveryDate(method.delivery_date)
    this.description = method.description
    this.carrier = new Carrier(method.carrier)
    this.address = new DropoffAddress(method.address)
    this.openingHours = method.opening_hours.map((day) => new OpeningHours(day))
    this.distance = method.distance
  }
}

export class DropoffMethods {
  mode: 'dropoff' = 'dropoff' as const
  methods: DropoffMethod[]

  constructor(method: DropoffMethodsDTO) {
    this.methods = method.methods.map(m => new DropoffMethod(m))
  }
}

export class DeliveryMethods {
  mode: 'delivery' = 'delivery' as const
  methods: DeliveryMethod[]

  constructor(method: ShipmentMethodsDTO) {
    this.methods = method.methods.map(m => new DeliveryMethod(m))
  }
}
